import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Colaborator = { id: string; name: string; url: string; created_at: Date; attachment: { url: string; }[]}

export function useGetColaborators() {
  return useFetch<Colaborator[]>(getAbsoluteServerUrl('/colaborators-logos'), { responseType: 'json' }, [])
}
